import { render, staticRenderFns } from "./PlayerModal.vue?vue&type=template&id=98a38750&"
import script from "./PlayerModal.vue?vue&type=script&lang=js&"
export * from "./PlayerModal.vue?vue&type=script&lang=js&"
import style0 from "./PlayerModal.vue?vue&type=style&index=0&id=98a38750&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports